import { render, staticRenderFns } from "./VisitRecordList.vue?vue&type=template&id=13a4a546&scoped=true"
import script from "./VisitRecordList.vue?vue&type=script&lang=js"
export * from "./VisitRecordList.vue?vue&type=script&lang=js"
import style0 from "./VisitRecordList.vue?vue&type=style&index=0&id=13a4a546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4a546",
  null
  
)

export default component.exports